import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import ValueLabel from "./ValueLabel";

const Bars = ({
  data,
  maxValue,
  showValueLabel,
  barWidth,
  barRadius,
  defaultColor,
  defaultDepth,
  onBarPositions,
}) => {
  const barRefs = useRef([]);

  useEffect(() => {
    if (!barRefs.current.length) return;

    const updatePositions = () => {
      const positions = barRefs.current.map((ref) => {
        if (!ref) return { left: 0, width: 0 };
        const rect = ref.getBoundingClientRect();
        return { left: rect.left, width: rect.width };
      });
      onBarPositions(positions);
    };

    updatePositions();

    const observer = new ResizeObserver(() => updatePositions());
    barRefs.current.forEach((ref) => ref && observer.observe(ref));

    return () => observer.disconnect();
  }, [data, barWidth, onBarPositions]);

  return (
    <div className="flex justify-around items-end w-full h-full relative z-10 gap-2">
      {data.map((item, i) => {
        const heightPercent = (item.value / maxValue) * 100;
        const barColor = `bg-${item.color || defaultColor}-${
          item.depth || defaultDepth
        }`;

        return (
          <div
            key={i}
            ref={(el) => (barRefs.current[i] = el)}
            className="relative flex flex-col items-center h-full justify-end flex-1"
          >
            <motion.div
              className={`${barColor}`}
              style={{
                width: barWidth,
                borderTopLeftRadius: barRadius,
                borderTopRightRadius: barRadius,
              }}
              initial={{ height: 0 }}
              animate={{ height: `${heightPercent}%` }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            />
            {showValueLabel && (
              <ValueLabel
                value={item.value}
                barHeight={heightPercent}
                color={item.color || defaultColor}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Bars;
